import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-series-three',
  templateUrl: './series-three.component.html',
  styleUrls: ['./series-three.component.scss']
})
export class SeriesThreeComponent implements OnInit {

  activateSummary = true;
  activateSeriesOne = false;
  activateSeriesTwo = false;
  activateSeriesThree = false;
  activateSeriesFour = false;

  constructor() { }

  ngOnInit(): void {
  }

  activateSeries(series) {
    switch (series) {
      case 1: { this.activateSeriesOne = true;
        this.activateSeriesTwo = false;
        this.activateSeriesThree = false;
        this.activateSeriesFour = false;
        break;
      }
      case 2: { this.activateSeriesOne = false;
        this.activateSeriesTwo = true;
        this.activateSeriesThree = false;
        this.activateSeriesFour = false;
        break;
      }
      case 3: { this.activateSeriesOne = false;
        this.activateSeriesTwo = false;
        this.activateSeriesThree = true;
        this.activateSeriesFour = false;
        break;
      }
      case 4: { this.activateSeriesOne = false;
        this.activateSeriesTwo = false;
        this.activateSeriesThree = false;
        this.activateSeriesFour = true;
        break;
      }
    }
  }

}
